<pdq-tabs-group variant="underline" (onChange)="onTabChange($event)" [leftMargin]="'none'">
  @for (tab of tabs; track tab.value) {
    <pdq-tab [label]="tab.label" [value]="tab.value" [active]="tab.value === activeTab"></pdq-tab>
  }
</pdq-tabs-group>

<div class="delivery-countdown-timer-form-container">
  @switch (activeTab) {
    @case (DeliveryCountdownTimerFormTab.CONFIGURATIONS) {
      <delivery-countdown-timer-form-configurations
        [formGroup]="formGroup"
        [shippingMethods]="shippingMethods"></delivery-countdown-timer-form-configurations>
    }
    @case (DeliveryCountdownTimerFormTab.APPEARANCE) {
      <delivery-countdown-timer-form-appearance [formGroup]="formGroup"></delivery-countdown-timer-form-appearance>
    }
    @case (DeliveryCountdownTimerFormTab.DISPLAY_CONDITIONS) {
      <delivery-countdown-timer-form-display-conditions
        [formGroup]="formGroup"
        [displayRules]="displayRules"
        [displayRulesEntities]="displayRulesEntities"
        [shopCurrencySymbol]="shopCurrencySymbol"></delivery-countdown-timer-form-display-conditions>
    }
  }
</div>
